import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { AuthService } from 'src/app/auth/auth.service';
import { DateRange, MomentHelper } from 'src/app/models/date';
import { ProductSearch } from 'src/app/models/product';
import { DownloadService } from 'src/app/reports/download-service';
 import { CommonService } from 'src/app/utilities/common-service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
 import { NzMessageService } from 'ng-zorro-antd/message';
import { EditMerchantProductComponent } from './edit-merchant-product/edit-merchant-product.component';
import { NewMerchantProductComponent } from './new-merchant-product/new-merchant-product.component';
 import { AssignLocationComponent } from './assign-location/assign-location.component';
import { AvailableLocationComponent } from './available-location/available-location.component';
 import * as moment from 'moment';
import { emptyFields, productTypeAllOptions, ReportTerminals, TierOptions } from 'src/app/utilities/common-file';
import { Messages } from 'src/app/utilities/message';
import { MerchantProductSearch } from 'src/app/models/merchant-product';
import { MerchantSearch } from 'src/app/models/merchant';
import { ProductService } from '../product.service';
 

@Component({
  selector: 'app-merchant-product',
  templateUrl: './merchant-product.component.html'
})
export class MerchantProductComponent implements OnInit {
  loading = false;
  emptyField = emptyFields;
  tierOptions = TierOptions;   //Only two needed,Need to check.//
  selectedProduct: any;
  showDownload: string;
  downloadList = [];
  productTypeOptions = productTypeAllOptions;
  appCodeOptions = [];
  selectedRateDateRange: Date[] = null;



  // For drawer Close when refresh custom token fails
  notifyLogout: any;

  // For App Code
  showAppCodeFilter = false;
  private tableDataForMerchants: NzTableData<MerchantSearch, any> = new NzTableData<MerchantSearch, any>(new MerchantSearch(), 'name');
  private tableData: NzTableData<MerchantProductSearch, any> = new NzTableData
    <MerchantProductSearch, any>(new MerchantProductSearch(), 'name');
  // productId: any;
  syncProductloading: boolean = false;
  ayopopBalanceloading: boolean = false;
  productId: number;
  refreshAlert:any;
  constructor(private drawerService: NzDrawerService,
     private authService: AuthService,
    private notification: NzNotificationService,
    private downloadService: DownloadService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private modal: NzModalService,
    private message: NzMessageService,
    private productService: ProductService
    ) {
  }
   ngOnInit() {
    this.refresh();
    this.productId = this.activatedRoute.snapshot.params.productId;
    this.refreshAlert = this.productService.refreshMerchantProduct.subscribe((val) => {
      if (val) {
          this.refresh();
       }
      });
  }
  // getAppCodeDetails() {
  //     this.tableData.search.appCode = this.authService.getAppCode(); // To Set Login User's appcode as default appcode while page loads
  //   this.tableData.search.createdDate = DateRange.empty();
  // }

  // For List
  refresh(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    const args = {
      merchantName: this.tableData.search.merchantName ? this.tableData.search.merchantName : '',
      category:this.tableData.search.category ? this.tableData.search.category:'',
      name: this.tableData.search.name ? this.tableData.search.name : '',
      startDate: this.tableData.search.startDate,
      endDate: this.tableData.search.endDate,
      pageSize: this.tableData.pageSize,
      pageIndex: this.tableData.pageIndex,
      appCode: this.authService.getAppCode(),
      merchantId:this.authService.getMerchantId()
    }
      this.productService.getMerchantProductWithLimit(args).subscribe((response: any) => {
       
        
      this.loading = false;
      this.tableData.total = response.data.total;
      if (response.data && response.data.merchantProduct) {
        this.tableData.data = response.data.merchantProduct;
        this.showDownload = Messages.downloadReport;
      } else {
        this.tableData.data = [];
        this.showDownload = '';
      }
    }, (err) => {
      this.loading = false;
      this.tableData.data = [];
      this.showDownload = '';
    });
  }

  // dateConverter(date){
  //   var dob = new Date(date);
  //   console.log('date',dob.toISOString().split('T')[0]);
  //   return dob.toISOString().split('T')[0];
  // }

  // For Page index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }

  // For Create Drawer
  createProduct() {
    const drawerRefCreate = this.drawerService.create<NewMerchantProductComponent, { productId: number }, string>({
      nzTitle: 'Create Product',
      nzContent: NewMerchantProductComponent,
      nzWidth: '700px',
      nzClosable: true,
      nzContentParams: {
        productId: this.productId,
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefCreate.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefCreate.close();
        }
      });
    });
    drawerRefCreate.afterClose.subscribe(res => {
      if (res && typeof res !== null) {
        this.refresh();
      }
    });
  }

  // For Edit
  editProduct(data) {
    this.selectedProduct = data;
    const drawerRefEdit = this.drawerService.create<EditMerchantProductComponent, { product: string, productId: number }, string>({
      nzTitle: this.selectedProduct.name + '-' + this.selectedProduct.id,
      nzContent: EditMerchantProductComponent,
      nzWidth: '700px',
      nzClosable: false,
      nzContentParams: {
        product: this.selectedProduct,
        productId: this.productId,
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefEdit.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefEdit.close();
        }
      });
    });
    drawerRefEdit.afterClose.subscribe(data => {
      if (data && typeof data !== null) {
        this.refresh();
      }
    });
  }

  // Clear Filters
  clearSearch(value) {
    return this.productService.clearProductSearchFields(this.tableData, value);
  }

  // For Merchant filter
  getMerchants() {
    
    const value = {
      appCode: this.authService.getAppCode()
    };
    this.productService.downloadReport(value).subscribe((response: any) => {
      this.tableDataForMerchants.data = response.data.merchants;
  }, err => {
    this.tableDataForMerchants.data = [];
  });
  }
  // getMerchantID($event) {
  //   this.tableData.search.merchantName= '';
  // }
  getDescription(element) {
    if (element.description) {
      return element.description;
    }
  }
  getNotes(element) {
    if (element.additionalNotes) {
      return element.additionalNotes;
    }
  }
  // To Show Status
  getStatus(status) {
    return this.commonService.getStatus(status);
  }
  // For User Status Tag color
  getStatusColor(status) {
    return this.commonService.getStatusColor(status);
  }
  //Get appCode 
  getMerchantCurrency(code){
    return  this.commonService.getCurrencySymbol(code);
  }

  getProducts() {
    this.syncProductloading = true;
    this.productService.syncProducts().subscribe((response: any) => {
      this.syncProductloading = false;
      this.refresh();
    }, (err) => {
      this.syncProductloading = false;
    });
  }

  getAyopopBalance() {
    this.ayopopBalanceloading = true;
    this.productService.getAyopopBalance().subscribe((response: any) => {
      this.ayopopBalanceloading = false;
      this.showConfirmationUpdate(response);
    }, (err) => {
      this.ayopopBalanceloading = false;
    });
  }

  showConfirmationUpdate(response) {
    var currency = this.getCurrency(response.data.currency);
    this.modal.info({
      nzTitle:  'Balance: ' + currency + ' ' + response.data.balance + '<br>PartnerID: ' + response.data.partnerId,
      nzOnOk: () => console.log('Info OK')
    });
  }

  getCurrency(currency) {
    return this.commonService.getCurrency(currency);
  }

  getProductConfirm() {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to get products?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.getProducts(),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel'),
    });
  }

  getBalanceConfirm() {
    this.modal.confirm({
      nzTitle: 'Are you sure you want to get balance?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.getAyopopBalance(),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel'),
    });
  }
    // For Changing Date range
    onUpdatedOnChange(range: any[]) {
      if (range.length <= 1) { return; }
      this.tableData.search.createdDate = MomentHelper.createDateRange(range);
      this.tableData.search.startDate = this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '';
      this.tableData.search.endDate = this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '';
      this.refresh();
    }
    updateClear(range: any[]) {
      if (range.length <= 1) {
        this.tableData.search.createdDate = DateRange.empty();
        this.tableData.search.startDate='';
        this.tableData.search.endDate='';
        return;
    }
    }
    // Assign Location
    assignLocation(data) {
    this.selectedProduct = data; 
    let merchantName = this.selectedProduct.name;
    const drawerRefEdit = this.drawerService.create<AssignLocationComponent, { product: string, productId: number}, string>({
      nzTitle: 'Assign Product to Location',// (' + this.selectedProduct.name + ')',
      nzContent: AssignLocationComponent,
      nzWidth: '890px',
      nzClosable: true,
      nzContentParams: {
        product: this.selectedProduct,
        productId: this.productId,
       },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefEdit.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefEdit.close();
        }
      });
    });
    drawerRefEdit.afterClose.subscribe(data => {
      if (data && typeof data !== null) {
        this.refresh();
      }
    });
  }
    // Availability Locations
    availabilityLocations(data) {
    this.selectedProduct = data; 
    const drawerRefEdit = this.drawerService.create<AvailableLocationComponent, { product: string, productId: number }, string>({
      nzTitle: 'Availability',// + this.selectedProduct.name + ')',
      nzContent: AvailableLocationComponent,
      nzWidth: '890px',
      nzClosable: true,
      nzContentParams: {
        product: this.selectedProduct,
        productId: this.productId,
      },
      nzBodyStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto'
      }
    });
    //  For drawer Close when refresh custom token fails
    drawerRefEdit.afterOpen.subscribe(() => {
      this.notifyLogout = this.authService.notify.subscribe((result) => {
        if (result) {
          drawerRefEdit.close();
        }
      });
    });
    drawerRefEdit.afterClose.subscribe(data => {
      if (data && typeof data !== null) {
        this.refresh();
      }
    });
  }
  // For Download Excel
  downloadReport() {
    if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
    this.notification.info('Download Processing', 'Please Wait', {
      nzKey: 'key'
    });
    const value = {
      merchantName: this.tableData.search.merchantName ? this.tableData.search.merchantName : '',
      name: this.tableData.search.name ? this.tableData.search.name : '',
      category:this.tableData.search.category ? this.tableData.search.category : '',
      startDate: this.tableData.search.startDate,
      endDate: this.tableData.search.endDate,
      appCode: this.tableData.search.appCode,
      merchantId:this.authService.getMerchantId()
    };
    // For filter headers
    const filterHeaders = ['Product Name','Category Name','Created On', (this.showAppCodeFilter) ? 'Appcode' : ''];

    // To Show Filtered data
    const filterData = [
       value.name ? value.name : '',
       value.category ? value.category : '',
       value.startDate && value.endDate ? moment(value.startDate).local().format('DD-MMM-YYYY') + ' to ' +
      moment(value.endDate).local().format('DD-MMM-YYYY') : '',
     // this.showAppCodeFilter ? (this.tableData.search.appCode ? this.authService.getAppCodeName(value) : 'All') : ''
    ];
    // API request
    this.productService.downloadMerchantProductReport(value).subscribe((response: any) => {
       this.downloadList = response.data.merchantProduct;
      if (this.downloadList.length > 0) {
         const headers = ['ID','Name','Code','Category','Description','Additional Notes','Price','Status', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];

        this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantProductReport, this.tableData.search.createdDate.startDate,
          this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantProductReport,
          ReportTerminals.merchantProductReport, filterHeaders, filterData);
      }
    });
  }else{
    this.notification.error(Messages.noDateSelected, '', {
      nzKey : 'key'
    });
  }
  }
}
